import React, { useEffect, useRef } from 'react';
import styles from '../styles/listSeparator.scss';
const ListSeparator = ({ id, pinnedElementId, title, renderCallback, }) => {
    const listItemRef = useRef(null);
    useEffect(() => {
        const listItem = listItemRef.current;
        renderCallback(id, listItem.offsetTop);
    }, []);
    const isPinned = id === pinnedElementId;
    const containerClass = isPinned ? styles.container_fixed : styles.container;
    return (React.createElement("li", { className: containerClass, ref: listItemRef },
        React.createElement("div", { className: styles.title }, title)));
};
export default ListSeparator;
